import { Pipe, PipeTransform } from '@angular/core';
import { arrayOnlyOne } from 'src/app/utils/array.utils';

@Pipe({
    name: 'arrayOnlyOne',
    standalone: false
})
export class ArrayOnlyOnePipe implements PipeTransform {
    transform(value: any[]): boolean {
        return arrayOnlyOne(value);
    }
}
